module.exports = __webpack_public_path__ + "img/img_6.c0a24fc5.png";